<template>
    <header class="header">
        <a class="header__pikabu" :href="$store.state.links.pikabu" target="_blank">
            <img class="header__pikabu-img" src="@/assets/images/pikabu-logo.svg" />
        </a>
        <a class="header__popup-btn" @click="onOpenPopup">
            <span class="header__popup-btn-text--desktop">Как зарабатывать на eBay</span>
            <span class="header__popup-btn-text--mobile">Бизнес на eBay</span>
            <icon-arrow-right class="header__popup-btn-icon" />
        </a>
        <a class="header__ebay" :href="$store.state.links.ebay" target="_blank">
            <img class="header__ebay-img" src="@/assets/images/ebay-logo.svg" />
        </a>

        <ui-popup ref="popup" fixed>
            <block-popup-ebay />
        </ui-popup>
    </header>
</template>

<script>
    export default {
        components: {},
        methods: {
            onOpenPopup () {
                this.$refs.popup.open()
            }
        },
        mounted () {
        }
    }
</script>

<style lang="stylus" scoped>
    .header {
        height 11.3rem
        display flex
        justify-content flex-start
        align-items center
        flex-shrink 0

        @media (max-width: 970px) {
            padding-left 2rem
            padding-right 2rem
        }

        +layout-sm() {
            min-height 6rem
            height 6rem
            padding 0 2rem
            box-sizing border-box
        }

        &__popup-btn {
            padding-left 0.8rem
            margin 0 auto 0 4.1rem
            color #382AEF
            background-color $color-light
            font-weight $font-bold
            display flex
            justify-content center
            align-items center
            font-size 1.5rem
            width 100%
            max-width 27.2rem
            height 4.6rem
            border-radius 2.3rem
            transition background-color 0.3s ease, color 0.3s ease
            cursor pointer
            +layout-sm() {
                height 3.2rem
                width auto
                padding 0 1rem
                font-size 1.3rem
            }
            +layout-xs() {
                padding-left 1.2rem
                margin-left 1rem
            }

            &:hover {
                background-color #669eff
                color $color-light

                .header__popup-btn-icon {
                    background-color $color-accent
                }
            }

            &:active {
                opacity 0.7
            }

            &-text--desktop {
                +layout-sm() {
                    display: none
                }
            }

            &-text--mobile {
                display none
                +layout-sm() {
                    position relative
                    top -1px
                    display inline-flex
                }
            }

            &-icon {
                margin-left 0.7rem
                border-radius 50%
                width 2.6rem
                height @width
                flex-shrink 0
                background-color #3665F3
                display flex
                justify-content: center;
                align-items center
                color $color-light
                position relative
                top 1px
                right -1px
                transition background-color 0.3s ease
                +layout-sm() {
                    top 0
                    right 0
                    width 1.4rem
                    height 1.4rem
                    line-height 0
                    margin-left 0.3rem
                }


                >>> svg {
                    position relative
                    top 0
                    left 1px
                    width 8px
                    height 14px
                    +layout-sm() {
                        width 5px
                        height 8px

                    }
                }
            }
        }

        &__pikabu {
            +layout-xs() {
                width 6.1rem
                display flex
            }

            &-img {
                +layout-xs() {
                    width 100%
                    max-width 100%
                    height 100%
                }
            }
        }

        &__ebay {
            +layout-xs() {
                width 5.1rem
                display flex
            }

            &-img {
                width 100%
                max-width 100%
            }
        }
    }
</style>

